<template lang="pug">
div(class="border-bottom btn-group flex-flex")
    ib-row()
        ib-button(
            @click="setTabValue('products')",
            class="ml-0 text-center tabs",
            :class="{ active: selectedTab === 'products', wid : !$media.s}"
        ) {{ $t('products') }}
        ib-button(
            @click="setTabValue('exchanges')",
            class="ml-0 text-center tabs",
            :class="{ active: selectedTab === 'exchanges', wid : !$media.s}"
        ) 
            span {{ $t('exchanges') }}
        ib-button(
            @click="setTabValue('contracts')",
            class="ml-0 text-center tabs",
            :class="{ active: selectedTab === 'contracts', wid : !$media.s}"
        ) 
            span {{ $t('contracts') }}
</template>

<script>
    import cloneDeep from 'lodash.clonedeep';
    import { mapState, mapActions, mapGetters} from 'vuex';

    export default {
        name: 'Services',
        data() {
            return {
                classes: {
                    'insety-8': $media.l,
                    'insety-2': !$media.m,                                            
                    'insetx-16': $media.l, 
                    'insetx-4': !$media.m
                },
                tabs: ["products", "exchanges", "contracts"],
            }
        },
        mounted() {
            if(this.$route.params.tab){
                if(!this.tabs.includes(this.$route.params.tab)){
                    this.$router.push('/');
                } else {
                    this.setTabValue(this.$route.params.tab);
                }
            }
        },
        watch: {
            '$route.params.tab'(to, from) {
                if(to != undefined){
                    if(!this.tabs.includes(to)){
                        this.$router.push('/');
                    } else {
                        console.debug("updating tab");
                        this.setTabValue(to);
                    }
                }
            },
        },
        methods: {
            setTabValue(value){
                const tempRegions = cloneDeep(this.regions);
                tempRegions.filter(region => {
                    if(region.selected === true) {
                        region.selected = false;
                    }
                });
                const tempTypes = cloneDeep(this.productTypes);
                tempTypes.filter(type => {
                    if(type.selected === true) {
                        type.selected = false;
                    }
                });
                
                this.setTab(value);
                this.setSelectedCountry('');
                this.setDefaultRegion('na');
                this.setRegions(tempRegions);
                this.setProductTypes(tempTypes);
                this.setNewProducts('all');
                this.setSelectedProduct('');
                this.setSelectedExchange('');
                this.setSelectedRegion([]);
                this.setSearchProductType([]);
            },
            ...mapActions(['setTab', 'setSelectedCountry', 'setDefaultRegion', 'setRegions', 'setProductTypes',
                'setNewProducts', 'setSelectedProduct', 'setSelectedExchange', 'setSelectedRegion', 'setSearchProductType'])
        },
        computed: {
            ...mapGetters(['selectedDomain']),
            ...mapState(['services','selectedTab','selectedCountry', 'defaultRegion', 'regions', 'productTypes'])
        },
    }
</script>

<style scoped lang="less">
@media (max-width:768px) {
    .tabs {
        width: 100%;
    }
}
.active {
    background-color: #D91222;
    color: #FFFFFF;
}
button {
    border-radius: 0;
}
.wid {
    width: 100%;
}
</style>